// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"0245c3f7","217":"6d055dc9","362":"83a6936a","492":"d317c57b"}[chunkId] + ".chunk.js";
};